export default __webpack_public_path__ + "static/media/ganesh.eed58192.jpeg";